import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getSkiReports() {
  try {
    const res = await tryCache(
      `getSkiReports-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getSkiSearch', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getSkiSearch failed.', error);
  }
}
